/* =============================================================
   PAGINA PROSPECTING — Serené Le Parfum
   Engine de selección de kit + add-to-cart real
   --------------------------------------------------------------
   - IIFE aislado, expone window.SerenePP solo para diagnóstico
   - Lee cart real al cargar (sincroniza si vienen de otra página)
   - Add-to-cart vía /cart/add.js (Shopify estándar)
   - Aplica descuento automático "SEGUNDA UNIDAD 50% OFF" (ya en Shopify)
   - Al llegar a 2/2: intenta abrir cart-drawer global, fallback /cart
   ============================================================= */
(function () {
  'use strict';

  if (window.SerenePP) return; // idempotente

  var KIT_MAX = 2;
  var ADD_URL = '/cart/add.js';
  var CART_URL = '/cart';
  var CART_JSON = '/cart.js';
  var CHANGE_URL = '/cart/change.js';
  var STORAGE_KEY = 'serene_pp_kit_v1';

  // Race protection: cuenta adds en vuelo para que clicks rápidos no
  // pasen el check state.items.size antes de que el primer fetch termine.
  var addInFlight = 0;

  // --- State ---
  // Map: variantId (string) -> { variantId, productId, productHandle, productTitle, addedAt }
  var state = {
    items: new Map(),
  };

  // --- DOM helpers ---
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, cb) { if (el) el.addEventListener(ev, cb); }

  function fmtCount() {
    return state.items.size + '/' + KIT_MAX;
  }

  // --- Persistence ---
  function loadLocal() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return;
      arr.forEach(function (it) {
        if (it && it.variantId) state.items.set(String(it.variantId), it);
      });
    } catch (e) { /* noop */ }
  }
  function saveLocal() {
    try {
      var arr = Array.from(state.items.values());
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) { /* noop */ }
  }

  // --- Cart sync (read real cart on load) ---
  function syncFromCart() {
    return fetch(CART_JSON, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Reset state to match cart, but only count items added by this page
        // We use a property tag to distinguish later. For now: rebuild state from
        // localStorage AND verify each persisted variant is actually in cart.
        var cartIds = new Set((cart.items || []).map(function (it) { return String(it.variant_id); }));
        // Drop persisted items that are no longer in real cart
        Array.from(state.items.keys()).forEach(function (vid) {
          if (!cartIds.has(vid)) state.items.delete(vid);
        });
        saveLocal();
        updateUI();
        updateCartBubble(cart.item_count || 0);
      })
      .catch(function () { /* offline ok */ });
  }

  function updateCartBubble(count) {
    $all('[data-pp-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  // --- Add to cart ---
  function addToCart(variantId, productMeta, btnEl) {
    if (state.items.has(String(variantId))) {
      // Already in kit, nothing to do
      return Promise.resolve({ alreadyAdded: true });
    }
    // Race protection: contar adds en vuelo hacia el cap
    if (state.items.size + addInFlight >= KIT_MAX) {
      toast('Tu kit ya tiene 2 perfumes. Limpia para cambiar.', true);
      return Promise.reject(new Error('kit_full'));
    }

    addInFlight++;
    var releaseLock = function () { addInFlight = Math.max(0, addInFlight - 1); };

    if (btnEl) {
      btnEl.classList.add('is-loading');
      btnEl.disabled = true;
    }

    var body = {
      items: [{
        id: Number(variantId),
        quantity: 1,
        properties: { '_pp': 'pagina-prospecting' }
      }]
    };

    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (data) {
        state.items.set(String(variantId), {
          variantId: String(variantId),
          productId: productMeta && productMeta.productId,
          productHandle: productMeta && productMeta.productHandle,
          productTitle: productMeta && productMeta.productTitle,
          addedAt: Date.now()
        });
        saveLocal();
        updateUI();
        if (btnEl) {
          btnEl.classList.remove('is-loading');
          btnEl.classList.add('is-added');
          btnEl.disabled = false;
          btnEl.dataset.label = btnEl.textContent;
          btnEl.innerHTML = '✓ Agregado';
        }
        toast(((productMeta && productMeta.productTitle) || 'Perfume') + ' agregado al kit', false);
        return syncFromCart().then(function () { return data; });
      })
      .then(function (data) {
        // If we just hit the cap, open cart drawer or redirect after a beat
        if (state.items.size >= KIT_MAX) {
          setTimeout(openCart, 800);
        }
        return data;
      })
      .catch(function (err) {
        if (btnEl) {
          btnEl.classList.remove('is-loading');
          btnEl.disabled = false;
        }
        var msg = (err && (err.description || err.message)) || 'No pudimos agregar al carrito';
        toast(msg, true);
        throw err;
      })
      // Liberar el lock siempre, exitoso o no. Compatible con browsers sin Promise.finally.
      .then(function (v) { releaseLock(); return v; }, function (e) { releaseLock(); throw e; });
  }

  // --- Remove from cart (used by clear) ---
  function removeFromCart(variantId) {
    return fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: 0 }),
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function clearKit() {
    var ids = Array.from(state.items.keys());
    if (!ids.length) return Promise.resolve();
    return Promise.all(ids.map(removeFromCart)).then(function () {
      state.items.clear();
      saveLocal();
      updateUI();
      return syncFromCart();
    }).catch(function () { /* ignore */ });
  }

  // --- Open cart ---
  function openCart() {
    // Este theme NO tiene cart-drawer programable: el <cart-drawer> es solo un
    // tag HTML sin customElements.define. Verificado contra todos los assets.
    // Patrón confirmado por kit-builder-50ml-b.js: redirect duro a /cart.
    window.location.href = CART_URL;
  }

  // --- UI update (sticky + product cards + counters) ---
  function updateUI() {
    var count = state.items.size;
    var has1 = count >= 1;
    var has2 = count >= 2;

    // Counters across page
    $all('[data-pp-kit-count]').forEach(function (el) { el.textContent = fmtCount(); });

    // Bars
    $all('[data-pp-bar="1"]').forEach(function (el) { el.classList.toggle('filled', has1); });
    $all('[data-pp-bar="2"]').forEach(function (el) { el.classList.toggle('filled', has2); });

    // Sticky text + CTA href dependiente de la vista actual
    var stickyText = '';
    var stickyCta = 'Seguir explorando';
    var stickyHref = '#';
    var bsAnchor = (currentView === 'home') ? '#pp-best-sellers' : '#pp-bs-' + currentView;
    var routeAnchor = (currentView === 'home') ? '#pp-route' : '#pp-cats-' + currentView;
    if (count === 0) {
      stickyText = 'Activa tu segundo perfume con 50% OFF.';
      stickyCta = 'Seguir explorando';
      stickyHref = routeAnchor;
    } else if (count === 1) {
      stickyText = 'Falta 1 perfume para activar el 50% OFF en el segundo.';
      stickyCta = 'Elegir el segundo';
      stickyHref = bsAnchor;
    } else {
      stickyText = 'Beneficio activo. Tu kit está listo.';
      stickyCta = 'Ir al carrito';
      stickyHref = CART_URL;
    }
    $all('[data-pp-sticky-text]').forEach(function (el) { el.textContent = stickyText; });
    $all('[data-pp-sticky-cta]').forEach(function (el) {
      el.textContent = stickyCta;
      el.setAttribute('href', stickyHref);
      // Override default behavior for cart action: open drawer
      el.onclick = (count >= KIT_MAX) ? function (e) { e.preventDefault(); openCart(); } : null;
    });

    // Show sticky after first interaction (or always after 2s of mount)
    var sticky = $('[data-pp-sticky]');
    if (sticky) {
      // Always visible once page is interactive — keep it minimal but informative
      sticky.classList.add('is-visible');
    }

    // Update product card buttons
    $all('[data-pp-add]').forEach(function (btn) {
      var vid = String(btn.getAttribute('data-pp-variant-id') || '');
      var inKit = state.items.has(vid);
      btn.classList.toggle('is-added', inKit);
      if (inKit) {
        if (!btn.dataset.label) btn.dataset.label = btn.textContent;
        btn.innerHTML = '✓ Agregado';
      } else if (btn.dataset.label) {
        btn.textContent = btn.dataset.label;
      }
      // If kit is full and this isn't already in kit, soften it
      btn.disabled = (!inKit && state.items.size >= KIT_MAX);
    });
  }

  // --- Toast ---
  var toastTimer = null;
  function toast(msg, isError) {
    var el = $('[data-pp-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-pp-toast', '');
      el.className = 'pp-toast' + (isError ? ' pp-toast--err' : '');
      document.body.appendChild(el);
    }
    el.className = 'pp-toast' + (isError ? ' pp-toast--err' : '');
    el.textContent = msg;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2400);
  }

  // --- Tabs (segmented section) ---
  function initTabs() {
    $all('[data-pp-tab-btn]').forEach(function (btn) {
      on(btn, 'click', function () {
        var target = btn.getAttribute('data-pp-tab-btn');
        var group = btn.closest('[data-pp-tabs]');
        if (!group) return;
        $all('[data-pp-tab-btn]', group).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        $all('[data-pp-tab-pane]', group).forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-pp-tab-pane') === target);
        });
      });
    });
  }

  // --- Smooth scroll to anchor ---
  function initScrollLinks() {
    $all('[data-pp-scroll-to]').forEach(function (el) {
      on(el, 'click', function (e) {
        var sel = el.getAttribute('data-pp-scroll-to');
        var target = sel && document.querySelector(sel);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // --- Bind add buttons ---
  function initAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pp-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      var vid = btn.getAttribute('data-pp-variant-id');
      if (!vid) return;
      var meta = {
        productId: btn.getAttribute('data-pp-product-id'),
        productHandle: btn.getAttribute('data-pp-product-handle'),
        productTitle: btn.getAttribute('data-pp-product-title')
      };
      addToCart(vid, meta, btn);
    });
  }

  // --- Bind clear button ---
  function initClear() {
    $all('[data-pp-clear]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        if (!state.items.size) return;
        if (!confirm('¿Limpiar tu kit y empezar de nuevo?')) return;
        clearKit().then(function () { toast('Kit limpiado.', false); });
      });
    });
  }

  // --- Bind cart-drawer trigger from landing-header ---
  function initCartTriggers() {
    $all('[data-pp-cart-trigger]').forEach(function (el) {
      on(el, 'click', function (e) {
        // Only intercept if we have a drawer to open; let normal /cart navigation happen if not
        var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (drawer) {
          e.preventDefault();
          openCart();
        }
      });
    });
  }

  // ===========================================================
  //  VIEW STATE MACHINE (SPA interna · home / hombre / mujer / unisex)
  // ===========================================================
  var VALID_VIEWS = ['home', 'hombre', 'mujer', 'unisex'];
  var currentView = 'home';

  function viewFromHash() {
    var h = (location.hash || '').replace(/^#\/?/, '').toLowerCase();
    return VALID_VIEWS.indexOf(h) >= 0 ? h : 'home';
  }

  function setView(name, opts) {
    name = VALID_VIEWS.indexOf(name) >= 0 ? name : 'home';
    if (name === currentView && !(opts && opts.force)) return;
    currentView = name;

    $all('[data-pp-view]').forEach(function (el) {
      var match = el.getAttribute('data-pp-view') === name;
      el.classList.toggle('is-active', match);
      if (match) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });

    document.documentElement.setAttribute('data-pp-current-view', name);

    // INICIO button visibility (se controla con CSS via [data-pp-current-view])
    // Triggers en route cards reflejan estado activo (opcional)
    $all('[data-pp-view-trigger]').forEach(function (b) {
      b.classList.toggle('is-active-target', b.getAttribute('data-pp-view-trigger') === name);
    });

    // Scroll a top siempre que cambia vista (suave)
    if (!(opts && opts.skipScroll)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Repintar UI del sticky para reflejar anchors de la nueva vista
    updateUI();

    // Push history (no en initial load ni en popstate)
    if (!(opts && opts.skipHistory)) {
      var newHash = name === 'home' ? '#/' : '#/' + name;
      if (location.hash !== newHash) {
        try { history.pushState({ ppView: name }, '', newHash); } catch (e) {}
      }
    }
  }

  function initViewSwitcher() {
    // Click triggers (route cards en home, INICIO en header)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pp-view-trigger]');
      if (!btn) return;
      var target = btn.getAttribute('data-pp-view-trigger');
      if (!target || VALID_VIEWS.indexOf(target) < 0) return;
      e.preventDefault();
      setView(target);
    });

    // Browser back/forward
    window.addEventListener('popstate', function () {
      setView(viewFromHash(), { skipHistory: true });
    });

    // Hash change (en algunos navegadores popstate no dispara con hash-only)
    window.addEventListener('hashchange', function () {
      setView(viewFromHash(), { skipHistory: true });
    });

    // Vista inicial: viene del hash o default home
    setView(viewFromHash(), { skipScroll: true, skipHistory: true });
  }

  // ===========================================================
  //  VIDEO AUTOPLAY — testimonios (IntersectionObserver controlled)
  // ===========================================================
  // Reproduce muted+playsinline cuando entra al viewport, pausa al salir.
  // Respeta pausas manuales del user (no auto-resume si user pausó).
  // Compat iOS Safari + Android Chrome via defensive muted/playsinline + .play().catch.
  function initVideoAutoplay() {
    if (!('IntersectionObserver' in window)) return; // graceful fallback en browsers viejos

    var vids = $all('[data-pp-root] .pp-testimonial-media video');
    if (!vids.length) return;

    vids.forEach(function (v) {
      // Defensive: garantizar atributos críticos para mobile autoplay
      try {
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', ''); // legacy iOS
      } catch (e) { /* noop */ }

      // userPaused flag: respetar pausas intencionales
      v.dataset.ppPause = '0';

      v.addEventListener('pause', function () {
        // Si esta pausa la disparó el observer, no marcar como user-pause
        if (v._ppObsPause) { v._ppObsPause = false; return; }
        v.dataset.ppPause = '1';
      });
      v.addEventListener('play', function () {
        v.dataset.ppPause = '0';
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) {
          if (v.dataset.ppPause === '1') return; // respeta pausa manual
          if (!v.paused) return; // ya está playing
          try {
            v.muted = true; // re-defensive: algunos browsers desactivan al pausar
            var p = v.play();
            if (p && typeof p.catch === 'function') {
              p.catch(function () { /* autoplay rejected — silent */ });
            }
          } catch (err) { /* noop */ }
        } else {
          if (!v.paused) {
            v._ppObsPause = true;
            try { v.pause(); } catch (err) { /* noop */ }
          }
        }
      });
    }, { threshold: [0, 0.5, 1] });

    vids.forEach(function (v) { io.observe(v); });
  }

  // --- Init ---
  function init() {
    if (!document.querySelector('[data-pp-root]')) return;
    // Counter es per-page-session (no persiste entre navegaciones / page loads).
    // Esto evita que el cart se abra "tras la primera fragancia" cuando en realidad
    // ya había items en cart de sesiones previas. Limpiar localStorage stale.
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    initViewSwitcher();
    initTabs();
    initScrollLinks();
    initAddButtons();
    initClear();
    initCartTriggers();
    initVideoAutoplay();
    updateUI();
    syncFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // --- Public diagnostic API ---
  window.SerenePP = {
    state: state,
    syncFromCart: syncFromCart,
    clearKit: clearKit,
    openCart: openCart,
    setView: setView,
    getView: function () { return currentView; },
    version: '2.0.0'
  };
})();
